import * as types from './constants';

const initialState = {
  results: [],
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Shopify Variant Stock
  [types.GET_SHOPIFY_VARIANT_STOCK_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_VARIANT_STOCK_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_VARIANT_STOCK_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_VARIANT_STOCK_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
